'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

function isWeakMap(value) {
    return value instanceof WeakMap;
}

exports.isWeakMap = isWeakMap;
